<template>
  <div class="certificate-box pd-y-4">
    <div class="pd-t-4">
      <el-image :src="require(`@/assets/logo-primary.png`)"></el-image>
    </div>
    <p class="color-primary text-font-16">
      e-Learning by AvocadoX
    </p>
    <p class="text-font-14 mg-y-less pd-t-4">
      ประกาศนียบัตรฉบับนี้เพื่อแสดงว่า
    </p>
    <p class="color-primary text-font-30 mg-y-less pd-t-5">
      {{ name }} {{ lastName }}
    </p>
    <p class="text-font-12 mg-y-less pd-t-3">ได้ผ่านการอบรมหลักสูตรออนไลน์</p>
    <p class="text-font-16 mg-y-less pd-t-5 text-break-word">
      หลักสูตร “{{ courseName }}”
    </p>
    <p class="text-font-14 color-gray mg-y-less pd-t-4">
      ณ วันที่ {{ endDate | dateThFull }}
    </p>
    <div class="pd-t-4 flex-display js-center">
      <div class="cercificate-img" :style="`background-image:url('${usrlSystem}${signatureImage.file}')`">
        
      </div>
      <!-- <el-image :src="`${usrlSystem}${signatureImage.file}`" ></el-image> -->
    </div>
    <p class="text-font-12 mg-y-less ">{{personSign}}</p>
    <p class="text-font-12 mg-y-less pd-b-4">{{position}}</p>
  </div>
</template>

<script>
import { HTTP } from "@/service/axios.js";

export default {
  props: {
    name: {
      type: String,
      default() {
        return "";
      },
    },
    lastName: {
      type: String,
      default() {
        return "";
      },
    },
    courseName: {
      type: String,
      default() {
        return "";
      },
    },
    endDate: {
      type: String,
      default() {
        return "";
      },
    },
  },
  data() {
    return {
      signatureImage: "",
      usrlSystem: process.env.VUE_APP_BASE_URL_SYSTEM,
      courseId: "",
      userId: "",
      position:"",
      personSign:"",
      
    };
  },
  mounted() {
    this.fetchGeneral();
  },
  methods: {
    fetchGeneral() {
      HTTP.get(`get/general`).then((res) => {
        if (res.data.success && res.data.obj) {
          this.signatureImage =
            typeof res.data.obj.imgInformation != "undefined"
              ? res.data.obj.imgInformation
              : null;
          this.position =
            typeof res.data.obj.position != "undefined"
              ? res.data.obj.position
              : null;
          this.personSign =
            typeof res.data.obj.personSign != "undefined"
              ? res.data.obj.personSign
              : null;
        }
      });
    },
  },
};
</script>

<style scoped>
.certificate-box {
  width: 750px;
  padding: 0 90px;
  min-height: 400px;
  /* background-image: url("../../assets/certificate-bg.png"); */
  background-color: #ffffff;
  border: 1px solid #dbdbdb;
  box-sizing: border-box;
  box-shadow: 3px 3px 3px rgba(196, 196, 196, 0.5);
  border-radius: 20px;
  text-align: center;
}
.cercificate-img{
  height: 44px;
  width: 100px;
  background-position: center;
  background-repeat: no-repeat;
  background-position: center center;
  background-size: cover;
}
</style>